import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ArrowLeft, Check, Lock } from "@phosphor-icons/react";
import api from "../lib/api";

const FEATURE_INFO = {
  campagne: ["Campagne marketing", "Pro"], whatsapp: ["WhatsApp", "Pro"],
  coupon: ["Coupon", "Pro"], giftcard: ["Gift Card", "Pro"], sondaggi: ["Sondaggi", "Pro"],
  automazioni: ["Automazioni", "Pro"], fidelity: ["Fidelity", "Pro"],
  coda: ["Coda walk-in", "Premium"], sms_wallet: ["Wallet SMS", "Premium"],
  centralino: ["Centralino telefonico", "Premium"],
};

export default function Upgrade() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const feat = params.get("feature") || "";
  const [label, minPlan] = FEATURE_INFO[feat] || ["Questa funzione", "Pro"];
  const [plan, setPlan] = useState(null);

  useEffect(() => {
    api.get("/billing/my-plan").then((r) => setPlan(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-lg mx-auto pt-10 sm:pt-16" data-testid="upgrade-page">
      <button onClick={() => navigate(-1)} data-testid="upgrade-back"
        className="flex items-center gap-1.5 text-sm text-zinc-500 hover:text-zinc-900 mb-6">
        <ArrowLeft size={15} weight="bold" /> Torna indietro
      </button>
      <div className="bg-white border border-zinc-200 rounded-2xl p-8 text-center">
        <span className="inline-flex w-14 h-14 rounded-full bg-zinc-100 border border-zinc-200 items-center justify-center">
          <Lock size={26} weight="duotone" className="text-zinc-500" />
        </span>
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-zinc-900 mt-5" data-testid="upgrade-title">
          {label} non è prevista dal tuo piano
        </h1>
        <p className="text-sm text-zinc-500 mt-3 leading-relaxed" data-testid="upgrade-sub">
          Il tuo piano attuale è <strong className="text-zinc-800">{plan?.plan_name || "—"}</strong>.
          {" "}{label} è disponibile dal piano <strong className="text-zinc-800">{minPlan}</strong>.
        </p>
        <div className="mt-6 text-left bg-zinc-50 border border-zinc-200 rounded-xl p-5">
          <p className="text-xs font-bold uppercase tracking-wider text-zinc-500 mb-3">Con {minPlan} sblocchi anche</p>
          <ul className="space-y-2">
            {(minPlan === "Pro"
              ? ["Campagne email e WhatsApp", "Coupon, gift card e sondaggi", "Automazioni e workflow", "Fidelity e segmenti avanzati"]
              : ["Tutto il piano Pro", "Coda walk-in e scanner QR", "Wallet SMS con pacchetti", "Centralino telefonico"]).map((f) => (
              <li key={f} className="flex items-center gap-2 text-sm text-zinc-700">
                <Check size={15} weight="bold" className="text-cyan-600 shrink-0" /> {f}
              </li>
            ))}
          </ul>
        </div>
        <a href={`mailto:info@cavadaconsulting.it?subject=${encodeURIComponent(`Richiesta upgrade piano ${minPlan}`)}&body=${encodeURIComponent(`Ciao, vorrei passare al piano ${minPlan} per sbloccare: ${label}.`)}`}
          data-testid="upgrade-cta"
          className="mt-6 w-full h-12 rounded-full bg-zinc-900 text-white text-sm font-bold flex items-center justify-center hover:bg-zinc-800 transition-colors">
          Richiedi l'upgrade a {minPlan}
        </a>
        <p className="text-[11px] text-zinc-400 mt-3">Ti rispondiamo entro 24 ore lavorative. L'upgrade è immediato e senza vincoli.</p>
      </div>
    </div>
  );
}
